import { v1 } from '@/api/client';
import type { LocalizationSettings, SettingType } from './api.types';

export const fetchLocalizationSettings = () =>
  v1.get<LocalizationSettings>('userpreference/settings/l10n');

export const updateLocalizationSetting = (
  setting: SettingType,
  value: string
) => v1.put(`userpreference/settings/l10n/${setting}`, { value });
